import { api } from '../../services/api';
import {
  GET_QUESTION_FAILURE, GET_QUESTION_SUCCESS,
  SAVE_QUESTION_FAILURE, SAVE_QUESTION_SUCCESS, SET_LOADING
} from '../reducers/types';

export const saveQuestion = (quest) => async (dispatch) => {
  try {
    dispatch({ type: SET_LOADING });
    const response = await api.post('/preguntas', { texto: quest });
    dispatch({ type: SAVE_QUESTION_SUCCESS, payload: response.data.success });
  } catch (error) {
    dispatch({ type: SAVE_QUESTION_FAILURE, payload: error.response.data.error });
  }
};

export const getQuestion = () => async (dispatch) => {
  try {
    dispatch({ type: SET_LOADING });
    const response = await api.get('/preguntas');
    dispatch({ type: GET_QUESTION_SUCCESS, payload: response.data.preguntas });
  } catch (error) {
    dispatch({ type: GET_QUESTION_FAILURE, payload: error });
  }
};
